import { render, staticRenderFns } from "./TrekRecaptcha.vue?vue&type=template&id=f8ae588c&"
import script from "./TrekRecaptcha.vue?vue&type=script&lang=js&"
export * from "./TrekRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports